module.exports = __webpack_public_path__ + "static/author-kaylee-pardoski-d23bd247071609fc869de15f9c554377.png";